export default __webpack_public_path__ + "static/media/giftCsv.8cd13267.csv";